import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowLoopDownLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconArrowLoopDownLeft"><Path d="M12 17.5H12.5C16.366 17.5 19.5 14.366 19.5 10.5C19.5 6.63401 16.366 3.5 12.5 3.5C8.63401 3.5 5.5 6.63401 5.5 10.5V20" stroke="currentColor"/><Path d="M1.5 16.5L5.5 20.5L9.5 16.5" stroke="currentColor"/></CentralIconBase>;
});

export default IconArrowLoopDownLeft;
